import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { OperatorMutationKeys } from '../../../keys'
import { CreateGroupRequest, CreateGroupResponse } from '../../../type'
import { createGroup } from '../../services'

export default function useMutationCreateGroup(
	props?: UseBaseMutationOptions<CreateGroupResponse, CreateGroupRequest>,
) {
	return useMutation({
		mutationKey: [OperatorMutationKeys.CreateGroup],
		mutationFn: (params) => createGroup(params),
		...props,
	})
}
